<template>
  <div class="ivu-row-flex-end ivu-row-flex" style="margin-left: -12px;margin-right: -12px;">
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="国家">
            <Input v-model="formItem.Country" placeholder="请输入国家..."></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;"
          class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24"
          >
      <FormItem :label-width="80" label="省">
            <Input v-model="formItem.Province" placeholder="请输入省份..."></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="市">
            <Input v-model="formItem.City" placeholder="请输入城市..."></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="区">
            <Input v-model="formItem.Region" placeholder="请输入地区..."></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="镇">
            <Input v-model="formItem.Township" placeholder="请输入镇..."></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem>
        <div style="float:right">
          <Button type="primary" style="margin-right:1rem" @click="QueryHandleClick">查询</Button>
          <Button style="margin-right:1rem" @click="ResetHandleClick">重置</Button>
        </div>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  name: 'FreightHeader',
  data () {
    return {
      formItem: {
        Country: '',
        Province: '',
        City: '',
        Region: '',
        Township: ''
      }
    }
  },
  methods: {
    // 点击查询按钮回调
    QueryHandleClick () {
      this.$emit('QueryHandleClick', this.formItem)
    },
    // 点击重置回调
    ResetHandleClick () {
      this.formItem = {
        Country: '',
        Province: '',
        City: '',
        Region: '',
        Township: ''
      }
      this.$emit('QueryHandleClick', this.formItem)
    }
  }
}
</script>
<style lang="scss" scoped>
@media (min-width: 576px) {
  .ivu-col-span-sm-24 {
    display: block;
    width: 100%;
  }
}
@media (min-width: 576px) {
  .ivu-col-span-xl-24 {
    float: left;
    flex: 0 0 auto;
  }
}
@media (min-width: 768px) {
    .ivu-col-span-md-12 {
      display: block;
      width: 50%;
   }
}
@media (min-width: 768px) {
  .ivu-col-span-xl-12 {
    float: left;
    flex: 0 0 auto;
  }
}
@media (min-width: 1200px) {
  .ivu-col-span-xl-8 {
    display: block;
    width: 33.33333333%;
   }
}
@media (min-width: 1200px) {
  .ivu-col-span-xl-8 {
    float: left;
    flex: 0 0 auto;
  }
}
.ivu-row-flex-end {
    justify-content: flex-end;
}
.ivu-row-flex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
</style>
